module.exports = __webpack_public_path__ + "static/img/gz.749924b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gz.png
// module id = mxwU
// module chunks = 1